/**
 * @generated SignedSource<<05d037f1f93207be4c7e4ef22e50cf2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AdminListBrandsRequest = {
  accountId?: string | null;
  includeArchived?: boolean | null;
  pageNumber?: number | null;
  pageSize?: number | null;
  search?: string | null;
};
export type BrandAccessSelectorQuery$variables = {
  input: AdminListBrandsRequest;
};
export type BrandAccessSelectorQuery$data = {
  readonly adminListBrands: {
    readonly data: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
  };
};
export type BrandAccessSelectorQuery = {
  response: BrandAccessSelectorQuery$data;
  variables: BrandAccessSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminBrandList",
    "kind": "LinkedField",
    "name": "adminListBrands",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminBrand",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandAccessSelectorQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandAccessSelectorQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "338a30422b70d7de3b84872949d1f25d",
    "id": null,
    "metadata": {},
    "name": "BrandAccessSelectorQuery",
    "operationKind": "query",
    "text": "query BrandAccessSelectorQuery(\n  $input: AdminListBrandsRequest!\n) {\n  adminListBrands(input: $input) {\n    data {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e96729bc7e980121a90f79321a115f72";

export default node;
